import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

let socket = null;

export const getSocket = () => {
  if (!socket) {
    socket = io(SOCKET_URL, { autoConnect: false, transports: ["websocket", "polling"] });
  }
  return socket;
};

export const connectSocket = (adminId, role) => {
  const s = getSocket();

  const doJoin = () => {
    s.emit("join-admin", adminId);
    if (role) s.emit("join-role", role);
  };

  if (s.connected) {
    doJoin();
  } else {
    s.once("connect", doJoin);
    s.connect();
  }
};

export const disconnectSocket = () => {
  if (socket?.connected) socket.disconnect();
};
